﻿import $ from "jquery";
import { GuiDetailGeneric } from "../../GuiDetailGeneric";
import { GuiFilterSort } from "../../GuiFilterSort";

    export class GuiDetailAnfallstelle extends GuiDetailGeneric {

        constructor() {
            super("Anfallstelle");
        }
        
        override attachEvents(): void {
            super.attachEvents();
            $("#btnCreateAdb").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.clickCreateAdb(e));
            new GuiFilterSort($("#anfallstelle-adb"), () => this.attachAdbListEvents());
        }

        // GuiFilterSort ersetzt die Zeilen per Ajax und ruft das auch beim Start auf. Dort hat
        // GuiDetailGeneric die Zeilen schon gebunden, daher off(): sonst liefe ein Klick doppelt.
        private attachAdbListEvents() {
            this.log("attachAdbListEvents");
            $("#anfallstelle-adb div.erz-list-element > div").not(".col-button").off("click").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => { this.clickDetailRow(e); });
            $("#anfallstelle-adb div.erz-list-element button.btn-erz-list-element-add").off("click").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => { this.clickDetailAdd(e); });
        }

        clickCreateAdb(e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
            this.log("clickCreateAdb");
            this.doAction(e);
        }

    }
